import {z} from 'zod';

import {isNotNil} from 'ramda';

import i18n from '@dms/i18n';

const requiredString = z.string().min(1, i18n.t('general.validations.fieldIsRequired'));

/**
 * A system definition has no branch of its own, so `branchId` stays nullable there and is
 * required for every other definition.
 */
export const getWorkshopInterestSeriesDefinitionFormSchema = (isSystemDefinition: boolean) =>
  z.object({
    name: requiredString,
    branchId: isSystemDefinition
      ? z.string().nullable()
      : requiredString
          .nullable()
          .refine(isNotNil, {message: i18n.t('general.validations.fieldIsRequired')}),
    seriesId: requiredString,
  });

export type WorkshopInterestSeriesDefinitionFormValues = z.infer<
  ReturnType<typeof getWorkshopInterestSeriesDefinitionFormSchema>
>;
